import { atob, btoa } from 'isomorphic-base64';

/**
 * Encode a JSON `object` as base-64 `string`.
 */
export function encodeToBase64(object: any): string {
    const content = JSON.stringify(object);
    const encoded = btoa(encodeURIComponent(content));
    return encoded;
}

/*
 * Decode a base-64 `string` to a JSON `object`.
 */
export function decodeFromBase64<T>(content: string): T {
    const decoded = decodeURIComponent(atob(content));
    const object = JSON.parse(decoded);
    return object;
}
